import { Link } from "react-router-dom";
import { CATEGORY_LABELS } from "../lib/constants";

// Numbered rail set in the display serif — the numerals are the ornament.
export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="panel p-7 sticky top-28">
            <div className="flex items-center gap-2.5">
                <span className="w-2 h-2 rounded-full bg-accent" />
                <h4 className="font-display text-xl font-semibold text-foreground">Trending Now</h4>
            </div>
            <div className="rule mt-4" />
            <ol className="divide-y divide-line">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-4 py-5"
                        >
                            <span className="font-display text-2xl font-semibold text-line-strong group-hover:text-accent transition-colors duration-200 w-8 shrink-0 leading-none pt-0.5 tabular-nums">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow !text-[10px] text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-sans text-[15px] font-medium leading-snug mt-1.5 text-foreground group-hover:text-accent transition-colors duration-200">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim py-5">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
